class BLoadMore extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', () => this.load());
  }

  async load() {
    const button = this.querySelector('button');
    const error = this.querySelector('.b-load-more__error');
    if (!this.dataset.nextUrl || !button) return;
    const url = new URL(this.dataset.nextUrl, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = document.getElementById('product-grid');
      const added = [];
      doc.querySelectorAll('#product-grid > .grid__item:not(.b-interstitial)').forEach((li) => {
        li.classList.remove('scroll-trigger', 'animate--slide-in');
        grid.appendChild(li);
        added.push(li);
      });
      // Se actualiza en su sitio: el botón (y su foco) sobreviven entre páginas.
      const next = doc.querySelector('b-load-more');
      const status = next?.querySelector('[data-load-status]');
      if (status) this.querySelector('[data-load-status]').textContent = status.textContent;
      const bar = next?.querySelector('.b-progress span');
      if (bar) this.querySelector('.b-progress span')?.setAttribute('style', bar.getAttribute('style') || '');
      if (next?.dataset.nextUrl) {
        this.dataset.nextUrl = next.dataset.nextUrl;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      } else {
        delete this.dataset.nextUrl;
        button.remove();
        this.querySelector('noscript')?.remove();
        added[0]?.querySelector('a')?.focus();
      }
    } catch {
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('b-load-more')) customElements.define('b-load-more', BLoadMore);
